@if (count) {
    <wdx-icon-label
        class="text-danger"
        icon="flag"
        iconStyle="fas"
        [label]="count?.toString()"
    ></wdx-icon-label>
}
@if (!count) {
    <span [attr.data-cy]="'issues-none'"> - </span>
}
